(() => {
  function init() {
    const configNode = document.querySelector('[data-spray-journey-config]');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!configNode || !drawer || window.HinokSprayJourney) return;
    const config = JSON.parse(configNode.textContent);
    const pdp = document.querySelector('[data-spray-journey-pdp]');
    const widget = pdp && pdp.querySelector('[data-journey-pdp]');
    const pdpHandle = pdp && pdp.dataset.productHandle;
    const isSprayPdp = pdpHandle === 'the-spray-set';
    const firstTab = drawer.querySelector('[data-cart-tab="a"]');
    const firstTabLabel = firstTab && firstTab.textContent;
    const storageKey = `hinok_spray_journey_${config.themeId}`;
    let enrolled = Boolean(widget && isSprayPdp);
    let intentVariant = null;
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      enrolled = enrolled || Boolean(saved);
      intentVariant = saved && saved.variant;
    } catch (error) {}
    function remember(variant) {
      intentVariant = variant || intentVariant;
      try { sessionStorage.setItem(storageKey, JSON.stringify({ variant: intentVariant })); } catch (error) {}
    }
    if (widget && isSprayPdp) remember();
    const number = name => Number(drawer.getAttribute(name)) || 0;
    const money = cents => new Intl.NumberFormat(config.locale, {
      style: 'currency', currency: config.currency, minimumFractionDigits: 0, maximumFractionDigits: 2
    }).format(cents / 100);
    const copy = (key, values = {}) => Object.entries(values).reduce(
      (text, [name, value]) => text.replace(`[${name}]`, value), config.copy[key] || ''
    );
    const lines = () => [...drawer.querySelectorAll('[data-cart-region="items"] [data-key]')]
      .filter(row => !row.hasAttribute('data-gwp-line'));
    const care = () => window.HinokCareGifting;
    function order(variant) {
      const handles = config.orders[config.variants[String(variant)]] || [];
      const discovery = drawer.querySelector('[data-cart-tabpanel="a"] [data-handle="hair-body-discovery-set"]');
      const discoveryAvailable = discovery && discovery.dataset.available === 'true';
      const mapped = handles.map(handle => handle === 'hair-body-discovery-set' && !discoveryAvailable
        ? 'essential-to-go-kit' : handle);
      if (care()?.enabled()) mapped.push('the-spray-to-go-100ml', 'the-body-wash-15-2-fl-oz-450ml', 'hair-body-discovery-set');
      return [...new Set(mapped)];
    }
    const giftEnabled = () => drawer.dataset.gwpEnabled === 'true' && number('data-gwp-threshold') > 0;
    const giftAvailable = () => drawer.dataset.gwpAvailable === 'true' || drawer.dataset.gwpFallbackAvailable === 'true';
    function cartContext() {
      const sprayLines = lines().filter(row => row.dataset.handle === 'the-spray-set');
      const anchor = sprayLines.find(row => row.dataset.variantId === String(intentVariant)) || sprayLines[0];
      const active = enrolled && Boolean(anchor);
      drawer.toggleAttribute('data-journey-active', active);
      if (firstTab) firstTab.textContent = active ? copy('pairs_well') : firstTabLabel;
      for (const element of drawer.querySelectorAll('.cart-item__journey')) {
        element.hidden = !active || !element.closest('[data-cart-tabpanel="a"]');
      }
      if (!active) return null;
      return { variantId: anchor.dataset.variantId, order: order(anchor.dataset.variantId) };
    }
    function giftMessage(type) {
      if (drawer.dataset.gwpTiered === 'true' || !drawer.hasAttribute('data-journey-active')) return null;
      return type === 'added' ? copy('gift_added') : type === 'qualifying' ? copy('gift_pending') : null;
    }
    function updateCartBenefits() {
      if (!drawer.hasAttribute('data-journey-active')) return;
      const total = number('data-gwp-qualifying-total');
      const shippingTotal = number('data-cart-total');
      const threshold = number('data-free-shipping-threshold');
      const label = drawer.querySelector('.cart-drawer__shipping-label');
      const fill = drawer.querySelector('.cart-drawer__progress-fill');
      if (label && threshold > 0) label.textContent = shippingTotal < threshold
        ? copy('shipping_away', { amount: money(threshold - shippingTotal) }) : copy('shipping_unlocked');
      const goal = care()?.enabled() ? care().progressThreshold(threshold) : threshold;
      if (fill && goal > 0) fill.style.inlineSize = `${Math.min(100, total / goal * 100)}%`;
      const gift = drawer.querySelector('[data-gwp-message]');
      if (gift && giftEnabled() && drawer.dataset.gwpTiered !== 'true') {
        if (!giftAvailable()) gift.textContent = copy('gift_unavailable');
        else if (total < number('data-gwp-threshold')) gift.textContent = copy('gift_away', { amount: money(number('data-gwp-threshold')) });
        else if (number('data-gwp-gift-count') === 1 && drawer.dataset.gwpGiftIsFree === 'true') gift.textContent = copy('gift_added');
      }
    }
    window.HinokSprayJourney = { cartContext, giftMessage, updateCartBenefits };
    document.dispatchEvent(new CustomEvent('spray-journey:ready'));
    if (!widget) return;

    const list = widget.querySelector('[data-journey-products]');
    const fieldset = widget.querySelector('[data-journey-fieldset]');
    const productTemplate = widget.querySelector('[data-journey-product-template]');
    const errorNode = widget.querySelector('[data-journey-error]');
    const buttons = [...pdp.querySelectorAll('[data-pdp-atc], [data-sticky-atc]')];
    const candidates = new Map([...drawer.querySelectorAll('[data-cart-tabpanel="a"] [data-reco]')].map(row => [row.dataset.handle, row]));
    const checked = new Set();
    const detailsPanel = widget.querySelector('pdp-pair-details');
    let pending = null;
    let retryItems = null;
    let pendingCart = null;
    let pendingItems = null;
    let uncertain = false;
    let lastCandidates = '';
    let lastVariant = null;
    let shownHandles = [];
    const extraComponents = {
      'the-spray-set': ['the-spray-refill', 'the-spray-bottle-empty'],
      'the-spray-gift-set': ['the-spray-set', 'the-spray-refill', 'the-spray-bottle-empty'],
      'the-spray-hand-wash-set': ['the-spray-set', 'the-spray-refill', 'the-spray-bottle-empty'],
      'hair-body-discovery-set': ['the-shampoo-15-2-fl-oz-450ml', 'the-conditioner-15-2-fl-oz-450ml', 'the-body-wash-15-2-fl-oz-450ml', 'the-hand-and-body-lotion-15-2-fl-oz-450ml'],
      'essential-to-go-kit': ['the-spray-to-go-100ml', 'the-hand-balm-35ml']
    };
    function includedHandles(handles) {
      const expanded = care()?.expandHandles(handles) || handles;
      return new Set(expanded.flatMap(handle => [handle, ...(extraComponents[handle] || [])]));
    }
    function selected() {
      return pdp.querySelector('.pdp-size.is-selected') || pdp.querySelector('[data-pdp-atc]');
    }
    function capture(name, properties) {
      if (window.posthog && window.posthog.capture) window.posthog.capture(name, {
        experiment: isSprayPdp ? 'spray_set_journey' : 'pdp_pair_recommendations',
        template: isSprayPdp ? 'spray-set-journey' : widget.dataset.journeyTemplate || 'default', product_handle: pdpHandle,
        variant_id: selected().dataset.variantId, gifting_promotion: care()?.enabled() ? drawer.dataset.gwpMarker : null, ...window.HinokPairsAB?.properties(), ...properties
      });
    }
    function inCartVariant(id) { return lines().some(row => row.dataset.variantId === String(id)); }
    function selectedItems() {
      const selection = selected();
      if (retryItems) return retryItems;
      const items = [];
      if (pdp.hinokSubscription?.active()) items.push(...pdp.hinokSubscription.items());
      else if (!isSprayPdp || !inCartVariant(selection.dataset.variantId)) items.push({ id: Number(selection.dataset.variantId), quantity: 1 });
      for (const handle of checked) {
        const row = candidates.get(handle);
        if (row && !inCartVariant(row.dataset.variantId)) items.push({ id: Number(row.dataset.variantId), quantity: 1 });
      }
      return items;
    }
    function addedPrice(items) {
      return items.reduce((sum, item) => {
        const subscriptionPrice = pdp.hinokSubscription?.priceFor(item.id);
        if (subscriptionPrice != null) return sum + subscriptionPrice * item.quantity;
        if (String(item.id) === selected().dataset.variantId) return sum + Number(selected().dataset.variantPrice || 0);
        const row = [...candidates.values()].find(candidate => candidate.dataset.variantId === String(item.id));
        return sum + (row ? Number(row.dataset.price) : 0);
      }, 0);
    }
    function detailsState(handle) {
      const row = candidates.get(handle);
      if (!row) return null;
      const inCart = inCartVariant(row.dataset.variantId);
      const isSelected = checked.has(handle);
      const price = Number(row.dataset.price) || 0;
      const selectionPrice = addedPrice(selectedItems()) + (isSelected || inCart ? 0 : price);
      const total = number('data-gwp-qualifying-total') + selectionPrice;
      const shippingTotal = number('data-cart-total') + selectionPrice;
      const shippingThreshold = number('data-free-shipping-threshold');
      const url = row.querySelector('.cart-item__title-link')?.getAttribute('href');
      return {
        handle, url, title: row.querySelector('.cart-item__title')?.textContent.trim() || '',
        volume: row.querySelector('.cart-item__volume')?.textContent.trim() || '',
        image: row.querySelector('img')?.currentSrc || row.querySelector('img')?.src,
        variantId: row.dataset.variantId, productId: row.dataset.productId, soldOut: row.dataset.available === 'false',
        selected: isSelected, inCart, price: money(price), currentTotal: money(addedPrice(selectedItems())), total: money(selectionPrice),
        shipping: shippingThreshold > 0 ? shippingTotal < shippingThreshold ? copy('shipping_away', {amount: money(shippingThreshold - shippingTotal)}) : copy('shipping_included') : '',
        gift: care()?.enabled() ? care().message(total, 'included') : '',
        busy: Boolean(pending) || uncertain,
        disabled: Boolean(pending) || uncertain || selected().dataset.available === 'false' || row.dataset.available === 'false'
      };
    }
    function setPairSelection(handle, isSelected, source) {
      const state = detailsState(handle);
      if (!state || state.busy || isSelected && (state.disabled || state.inCart)) return;
      retryItems = null;
      if (isSelected) checked.add(handle);
      else checked.delete(handle);
      update();
      capture('pdp_reco_selection_changed', {candidate_handle: handle, selected: isSelected, selected_total_cents: addedPrice(selectedItems()), source});
    }
    function renderCandidates() {
      const selection = selected();
      const cartHandles = new Set([...drawer.querySelectorAll('[data-cart-region="items"] [data-handle]')].map(row => row.dataset.handle));
      for (const row of drawer.querySelectorAll('[data-gwp-line]')) {
        const tier = care()?.tiers().find(item => item.key === row.dataset.gwpTier);
        if (tier) cartHandles.add(tier.handle);
        if (row.dataset.gwpTier === 'care-pair') care()?.tiers().forEach(giftTier => cartHandles.add(giftTier.handle));
      }
      const excluded = includedHandles([...cartHandles, pdpHandle]);
      for (const handle of checked) if (cartHandles.has(handle)) checked.delete(handle);
      const total = number('data-gwp-qualifying-total') + addedPrice(selectedItems());
      const candidateData = {};
      for (const [handle, row] of candidates) candidateData[handle] = {
        handle, price: Number(row.dataset.price), available: row.dataset.available !== 'false'
      };
      let ordered = isSprayPdp ? order(selection.dataset.variantId) : widget.dataset.journeyOrder.split(',');
      ordered = ordered.filter(handle => candidateData[handle]?.available
        && ![...includedHandles([handle])].some(component => excluded.has(component)));
      if (care()?.enabled()) {
        if (isSprayPdp) ordered = care().rank(ordered, candidateData, total, [...excluded]);
        else ordered = ordered.filter(handle => {
          const candidate = candidateData[handle];
          const promised = care().eligible(total + candidate.price).map(tier => tier.handle);
          return !care().decision(candidate, total, [...excluded]).blocked
            && ![...includedHandles([handle])].some(component => promised.includes(component));
        });
      }
      const preserved = [...checked].filter(handle => candidates.has(handle));
      const kept = shownHandles.filter(handle => preserved.includes(handle) || ordered.includes(handle) || candidates.get(handle)?.dataset.available === 'false');
      const handles = [...new Set([...kept, ...preserved, ...ordered])].slice(0, 2);
      shownHandles = handles;
      const signature = handles.map(handle => `${handle}:${candidates.get(handle).dataset.available}:${candidates.get(handle).dataset.price}`).join('|');
      fieldset.hidden = handles.length === 0;
      if (signature !== lastCandidates) {
        const focusedHandle = list.contains(document.activeElement) ? document.activeElement.value : null;
        lastCandidates = signature;
        list.replaceChildren();
        for (const handle of handles) {
          const source = candidates.get(handle);
          const fragment = productTemplate.content.cloneNode(true);
          const input = fragment.querySelector('input');
          input.value = handle;
          input.checked = checked.has(handle);
          input.id = `journey-pair-${widget.dataset.journeySection}-${source.dataset.variantId}`;
          fragment.querySelectorAll('[data-journey-label]').forEach(label => { label.htmlFor = input.id; });
          const image = fragment.querySelector('img');
          const sourceImage = source.querySelector('img');
          if (source.dataset.pairImage) {
            image.src = source.dataset.pairImage;
          } else if (sourceImage) {
            image.src = sourceImage.currentSrc || sourceImage.src;
            const fallback = sourceImage.getAttribute('onerror');
            if (fallback) image.setAttribute('onerror', fallback);
          }
          const fields = { name: '.cart-item__title', volume: '.cart-item__volume', description: '[data-journey-description]' };
          for (const [name, selector] of Object.entries(fields)) {
            const sourceNode = source.querySelector(selector);
            fragment.querySelector(`.spray-journey__${name}`).textContent = sourceNode ? sourceNode.textContent : '';
          }
          fragment.querySelector('.spray-journey__price').textContent = money(Number(source.dataset.price));
          const details = fragment.querySelector('[data-journey-details]');
          if (details) {
            details.hidden = widget.dataset.pairsVariant !== 'B';
            details.dataset.handle = handle;
            details.setAttribute('aria-label', copy('details_label', {product: fragment.querySelector('.spray-journey__name').textContent}));
            if (detailsPanel?.dialog?.id) details.setAttribute('aria-controls', detailsPanel.dialog.id);
          }
          list.appendChild(fragment);
        }
        if (focusedHandle) [...list.querySelectorAll('[data-journey-select]')]
          .find(input => input.value === focusedHandle)?.focus({ preventScroll: true });
      }
      for (const input of list.querySelectorAll('[data-journey-select]')) {
        const handle = input.value;
        const source = candidates.get(handle);
        input.checked = checked.has(handle);
        input.disabled = source.dataset.available === 'false' && !checked.has(handle) || Boolean(pending) || uncertain;
        const notice = input.closest('li').querySelector('[data-journey-paid-notice]');
        if (notice) {
          const duplicate = care()?.enabled() && care().eligible(total).some(tier => care().expandHandles([handle]).includes(tier.handle));
          notice.hidden = !checked.has(handle) || !duplicate && source.dataset.available !== 'false';
          notice.textContent = source.dataset.available === 'false' ? copy('selection_unavailable') : copy('paid_selection');
        }
      }
    }
    function update() {
      if (lastVariant !== selected().dataset.variantId) {
        lastCandidates = '';
        shownHandles = [];
        lastVariant = selected().dataset.variantId;
      }
      renderCandidates();
      const items = selectedItems();
      const setParts = items.filter(item => item.properties?._hinok_subscription_set?.startsWith('spray-')).length;
      const purchaseCount = items.length - Math.max(0, setParts - 1);
      const price = addedPrice(items);
      const total = number('data-gwp-qualifying-total') + price;
      const shippingTotal = number('data-cart-total') + price;
      const benefits = widget.querySelector('.spray-journey__benefits');
      if (!window.hinokRenderPdpBenefits?.(benefits, total, items.length > 0, shippingTotal)) {
        const shippingThreshold = number('data-free-shipping-threshold');
        const shipping = widget.querySelector('[data-journey-shipping]');
        const progress = widget.querySelector('[data-journey-progress]');
        shipping.hidden = shippingThreshold <= 0;
        const benefitGoal = care()?.enabled() ? care().progressThreshold(shippingThreshold) : shippingThreshold;
        progress.parentElement.hidden = benefitGoal <= 0;
        if (benefitGoal > 0) progress.style.inlineSize = `${Math.min(100, total / benefitGoal * 100)}%`;
        if (shippingThreshold > 0) {
          shipping.textContent = shippingTotal < shippingThreshold ? copy('shipping_away', { amount: money(shippingThreshold - shippingTotal) }) : copy(items.length ? 'shipping_included' : 'shipping_unlocked');
        }
        const gift = widget.querySelector('[data-journey-gift]');
        gift.hidden = care()?.enabled() ? !care().tiers().some(tier => tier.available) : !giftEnabled() || !giftAvailable();
        if (care()?.enabled()) gift.textContent = items.length ? care().message(total, 'included') : drawer.querySelector('[data-gwp-message]')?.textContent || care().message(total);
        else if (!gift.hidden) {
          if (total < number('data-gwp-threshold')) gift.textContent = copy('gift_away', { amount: money(number('data-gwp-threshold')) });
          else if (items.length) gift.textContent = copy('gift_included');
          else gift.textContent = drawer.querySelector('[data-gwp-message]')?.textContent || '';
        }
      }
      for (const button of buttons) {
        const label = button.querySelector('.pdp-atc__label, .pdp-sticky__atc-label');
        const priceNode = button.querySelector('[data-pdp-atc-price], [data-sticky-atc-price]');
        const text = pending ? copy('adding') : purchaseCount > 1 ? copy('add_items', { count: purchaseCount }) : items.length ? copy('add_to_cart') : copy('view_cart');
        if (label) label.textContent = text;
        if (priceNode) { priceNode.textContent = money(price); priceNode.hidden = items.length === 0; }
        button.setAttribute('data-pdp-purchase-total', String(price));
        button.disabled = Boolean(pending) || uncertain || (pdp.hinokSubscription?.active() && !pdp.hinokSubscription.ready()) || selected().dataset.available === 'false' || [...checked].some(handle => candidates.get(handle)?.dataset.available === 'false');
        button.setAttribute('aria-busy', pending ? 'true' : 'false');
      }
      fieldset.disabled = Boolean(pending) || uncertain || selected().dataset.available === 'false';
      for (const control of pdp.querySelectorAll('.pdp-size, [data-sticky-select], [data-refill-subscription] input, [data-refill-subscription] select, [data-refill-subscription] button')) control.disabled = Boolean(pending) || uncertain || control.dataset.unavailable === 'true';
      if (detailsPanel?.state && detailsPanel.dialog?.open) detailsPanel.update(detailsState(detailsPanel.state.handle));
      pdp.dispatchEvent(new CustomEvent('pdp:purchase-total-change'));
    }
    list.addEventListener('change', event => {
      if (!event.target.matches('[data-journey-select]')) return;
      setPairSelection(event.target.value, event.target.checked, 'checkbox');
    });
    list.addEventListener('click', event => {
      const button = event.target.closest('[data-journey-details]');
      if (!button || button.disabled || fieldset.disabled || !detailsPanel?.open) return;
      const state = detailsState(button.dataset.handle);
      if (!state?.url) return;
      detailsPanel.open(button, state);
      capture('pdp_reco_details_opened', {candidate_handle: state.handle, selected: state.selected});
    });
    detailsPanel?.addEventListener('pair-details:full-page', event => capture('pdp_reco_full_product_opened', {candidate_handle:event.detail.handle}));
    detailsPanel?.addEventListener('pair-details:select', event => setPairSelection(event.detail.handle, event.detail.selected, 'details_panel'));
    pdp.addEventListener('pdp:variant-change', () => { retryItems = null; update(); });
    pdp.addEventListener('pdp:subscription-change', () => { retryItems = null; update(); });
    document.addEventListener('cart:rendered', () => { shownHandles = []; update(); });
    async function json(url) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, {headers: {Accept:'application/json'}, signal:controller.signal, cache:'no-store'});
        if (!response.ok) throw new Error(copy('error'));
        return await response.json();
      } finally { clearTimeout(timeout); }
    }
    function quantity(cart, item) {
      return (cart?.items || []).filter(line => {
        if (String(line.variant_id) !== String(item.id)) return false;
        const group = item.properties?._hinok_subscription_set;
        if (!group) return !line.selling_plan_allocation;
        return line.properties?._hinok_subscription_set === group &&
          String(line.selling_plan_allocation?.selling_plan.id || '') === String(item.selling_plan || '');
      }).reduce((sum, line) => sum + line.quantity, 0);
    }
    document.addEventListener('cart:add:done', async event => {
      const detail = event.detail || {};
      if (!pending || pending !== detail.requestId) return;
      uncertain = detail.reconciled === false;
      if (detail.ok) { checked.clear(); retryItems = null; }
      else {
        try {
          const cart = await json((window.Shopify?.routes?.root || '/') + 'cart.js');
          retryItems = pendingItems.map(item => ({...item,quantity:Math.max(0,item.quantity - Math.max(0,quantity(cart,item)-quantity(pendingCart,item)))})).filter(item => item.quantity > 0);
          uncertain = false;
        } catch(error) { uncertain = true; }
      }
      pending = null;
      errorNode.hidden = detail.ok;
      errorNode.textContent = detail.error || copy('error');
      update();
      capture(detail.ok ? 'pdp_journey_add_succeeded' : 'pdp_journey_add_failed', {reconciled:!uncertain});
    });
    pdp.hinokJourney = {
      async add() {
        if (pending || uncertain || selected().dataset.available === 'false') return;
        const items = selectedItems().map(item => ({...item}));
        if (!items.length) { document.dispatchEvent(new CustomEvent('cart:open')); return; }
        if (isSprayPdp) remember(selected().dataset.variantId);
        pending = `pdp-journey-${crypto.randomUUID()}`;
        errorNode.hidden = true;
        update();
        try {
          const handles = [...new Set([pdpHandle, ...(pdp.hinokSubscription?.active() ? pdp.hinokSubscription.handles : []), ...checked])];
          const [cart, ...products] = await Promise.all([json((window.Shopify?.routes?.root || '/')+'cart.js'), ...handles.map(handle => json((window.Shopify?.routes?.root || '/')+'products/'+encodeURIComponent(handle)+'.js'))]);
          let changed = false;
          for (const item of items) {
            const product = products.find(p => p.variants?.some(v => v.id === item.id));
            const variant = product?.variants.find(v => v.id === item.id);
            if (!variant) throw new Error(copy('selection_changed'));
            const main = String(item.id) === selected().dataset.variantId;
            const row = [...candidates.values()].find(candidate => candidate.dataset.variantId === String(item.id));
            const oldPrice = pdp.hinokSubscription?.priceFor(item.id) ?? (main ? Number(selected().dataset.variantPrice) : Number(row?.dataset.price));
            if (variant.price !== oldPrice || !variant.available) changed = true;
            if (item.selling_plan && !variant.selling_plan_allocations?.some(allocation => allocation.selling_plan_id === item.selling_plan && allocation.price === oldPrice)) changed = true;
            pdp.hinokSubscription?.refresh(variant);
            if (row) {row.dataset.price=variant.price;row.dataset.available=String(variant.available);}
            if (main) {
              for (const control of pdp.querySelectorAll('[data-variant-id]')) if (control.dataset.variantId === String(item.id)) {
                control.dataset.variantPrice=variant.price;control.dataset.price=money(variant.price);control.dataset.available=String(variant.available);
                const priceNode=control.querySelector('.pdp-size__price');if(priceNode)priceNode.textContent=money(variant.price);
                const unitNode=control.querySelector('.pdp-size__unit');
                if(unitNode && Number(control.dataset.unitVolume)>0)unitNode.textContent=money(Math.round(variant.price/Number(control.dataset.unitVolume)))+'/fl.oz.';
              }
            }
          }
          if (changed) {retryItems=null;pdp.dispatchEvent(new CustomEvent('pdp:availability-change'));throw new Error(copy('selection_changed'));}
          pendingCart=cart;
          pendingItems=items;
          document.dispatchEvent(new CustomEvent('cart:add', {detail:{id:items[0].id,items,quantity:1,handle:pdpHandle,requestId:pending,source:'pdp'}}));
        } catch(error) {
          pending=null;
          errorNode.hidden=false;
          errorNode.textContent=error.message || copy('error');
          update();
        }
      }
    };
    widget.hidden = false;
    update();
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        capture('pdp_journey_viewed', { shipping_threshold_cents: number('data-free-shipping-threshold'), gift_threshold_cents: number('data-gwp-threshold') });
        observer.disconnect();
      }
    }, { threshold: 0.5 });
    observer.observe(widget);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
